import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { mockData } from '../data/mock';

const GallerySection = () => {
  const { language } = useLanguage();

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-4">
            {language === 'de' ? 'Eindrücke aus unseren Kursen' : 'Impressions from our courses'}
          </h2>
          <p className="text-neutral-600 max-w-2xl mx-auto">
            {language === 'de'
              ? 'Moderne Räumlichkeiten und praxisnahe Ausbildung in angenehmer Atmosphäre'
              : 'Modern facilities and practical training in a pleasant atmosphere'}
          </p>
        </div>

        <div className="gallery-grid">
          {mockData.images.gallery.map((image, index) => (
            <div
              key={index}
              className="gallery-item"
            >
              <img
                src={image}
                alt={`Erste-Hilfe Kurs Impression ${index + 1}`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
